/* Djurslottet enhancements:
   1) Variant PRICE inside the product page's MAIN add-to-cart button (+ sticky bar).
   2) THUMBNAILS follow the main image smoothly.
   3) QUICK-ADD MODAL: original native variant picker instead of the custom cards.
   4) OPUS CART DRAWER (event-driven, NO continuous observer, NO reflow on quantity change):
      on a +/- or delete click INSIDE the drawer:
        a) hide the 'Spara X kr' (.cd-discount-price) line until the recalculated value
           settles, so the transient wrong amount is never shown (native-feeling);
        b) if the cart becomes empty, click the drawer's close button (auto-close).
   Additive, idempotent, no core-theme files touched. */
(function () {
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function onProductPage() { return location.pathname.indexOf('/products/') > -1; }

  if (!document.getElementById('dj-atc-style')) {
    var st = document.createElement('style');
    st.id = 'dj-atc-style';
    st.textContent = '.dj-atc-price{margin-left:6px;font-weight:600;opacity:.94;white-space:nowrap;}'
      + '@media (max-width:749px){'
      + '.product-form-buttons--stacked{flex-direction:row !important;flex-wrap:nowrap !important;align-items:stretch !important;gap:8px !important;}'
      + '.product-form-buttons--stacked > .quantity-selector-wrapper{flex:0 0 auto !important;}'
      + '.product-form-buttons--stacked > span:last-child{flex:1 1 auto !important;min-width:0 !important;}'
      + '.product-form-buttons--stacked .add-to-cart-text{flex-wrap:wrap !important;row-gap:1px;}'
      + '.product-form-buttons--stacked .add-to-cart-text__content{white-space:nowrap;}'
      + '.product-form-buttons--stacked .dj-atc-price{flex:0 0 100% !important;margin-left:0 !important;text-align:center;font-size:.8em;line-height:1.1;opacity:.92;}'
      + '}'
      + '.quick-add-modal .dj-vp{display:none !important;}'
      + '.dj-cart-updating [class*="cd-discount-price"]{visibility:hidden !important;}'
      /* collapse EMPTY Shopify app blocks (size-chart / subscription app that render nothing on non-subscription products) so they do not each eat a flex row-gap under the variant picker; a block with real UI (active subscription radios) has element content in its div so :has(div *) keeps it visible - subscription products are never hidden */
      + '.product-information__grid .layout-panel-flex > .shopify-app-block:not(:has(> :not(style):not(script):not(link):not(noscript):not(div))):not(:has(div *)){display:none !important;}'
      /* quick-add popup: keep the add-to-cart icon + label on ONE row (the label is shortened to "Lägg i varukorgen" via JS) */
      + '.quick-add-modal button[name="add"] .add-to-cart-text{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;align-items:center;gap:6px;}'
      + '.quick-add-modal button[name="add"] .add-to-cart-text__content{white-space:nowrap;}'
      /* quick-add popup: make the thumbnail strip clickable (theme sets pointer-events:none on the gallery); dj scrolls the image into view on click */
      + '.quick-add-modal__content .product-information__media slideshow-controls,.quick-add-modal__content .product-information__media .slideshow-controls__thumbnail,.quick-add-modal__content .product-information__media slideshow-control{pointer-events:auto !important;cursor:pointer;}';
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------- 4) Opus cart drawer: hide the Spara flash + auto-close (event-driven) ---------- */
  function installCartFeatures() {
    if (document.__djCartFeat) return;
    document.__djCartFeat = true;
    function isOpen(d) { var r = d.getBoundingClientRect(); return r.width > 0 && r.left < window.innerWidth - 20 && r.right > 0; }
    function closeBtn(d) {
      var i = d.querySelector('button[class*="-close"], [class*="-close"]');
      if (i) return i;
      var m = (d.className || '').match(/drawer-cd-up-app-([A-Za-z0-9]+)/);
      return m ? document.querySelector('.drawer-cd-up-app-' + m[1] + '-close') : null;
    }
    function lineCount(d) { return d.querySelectorAll('[class*="cd-product-item-delete"]').length; }
    // Find the CURRENTLY open drawer live (Opus keeps several instances in the DOM and
    // may replace the drawer node when the last line is removed, so never trust a node
    // captured at click time — re-query on every tick).
    function openDrawer() {
      var ds = qa('div[class*="drawer-cd-up-app-"]'), i;
      for (i = 0; i < ds.length; i++) { if (/(^|\s)right(\s|$)/.test(ds[i].className) && isOpen(ds[i])) return ds[i]; }
      for (i = 0; i < ds.length; i++) { if (isOpen(ds[i])) return ds[i]; }
      return null;
    }
    // Hide the 'Spara X kr' line while the value recalculates; reveal only when it has
    // changed AND stayed stable (so the wrong intermediate value is never visible).
    function hideSavings(d) {
      d.classList.add('dj-cart-updating');
      var pel = d.querySelector('[class*="cd-discount-price"]');
      var pre = pel ? pel.textContent.trim() : '';
      var prev = null, stable = 0, ticks = 0;
      var iv = setInterval(function () {
        ticks++;
        var el = d.querySelector('[class*="cd-discount-price"]');
        var txt = el ? el.textContent.trim() : '';
        var changed = txt !== pre;
        if (changed && txt === prev) stable++; else stable = 0;
        prev = txt;
        if ((changed && stable >= 2) || ticks >= 20) { clearInterval(iv); d.classList.remove('dj-cart-updating'); }
      }, 80);
      setTimeout(function () { clearInterval(iv); d.classList.remove('dj-cart-updating'); }, 2500);
    }
    // After a remove/decrement, poll the LIVE open drawer; when it is empty for two
    // consecutive checks AND still open, click its close button (auto-close). One poller
    // at a time; re-queries the live drawer each tick so a replaced node can't strand it.
    function scheduleClose() {
      if (document.__djClosing) return;
      document.__djClosing = true;
      var n = 0, empties = 0;
      var iv = setInterval(function () {
        n++;
        var d = openDrawer();
        if (d) {
          if (lineCount(d) === 0) {
            if (++empties >= 2) { clearInterval(iv); document.__djClosing = false; var b = closeBtn(d); if (b) { try { b.click(); } catch (e) {} } return; }
          } else { empties = 0; }
        } else if (n >= 3) { clearInterval(iv); document.__djClosing = false; return; }
        if (n >= 30) { clearInterval(iv); document.__djClosing = false; }
      }, 120);
    }
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var d = t.closest('div[class*="drawer-cd-up-app-"]'); if (!d) return;
      var qty = t.closest('.cd-number-input-button');
      var del = t.closest('[class*="cd-product-item-delete"]');
      if (!qty && !del) return;
      if (qty) hideSavings(d);
      scheduleClose();
    }, true);
  }

  /* ---------- 3) Quick-add modal: reveal native picker, hide custom cards ---------- */
  function fixModalVariants() {
    var modals = qa('dialog.quick-add-modal[open], .quick-add-modal[open]');
    modals.forEach(function (modal) {
      var vp = modal.querySelector('.dj-vp');
      if (vp) vp.style.setProperty('display', 'none', 'important');
      // Reveal the native picker EVERY tick (no one-time guard): the theme's desktop whitelist
      // CSS keeps hiding it (it lives OUTSIDE <variant-picker>) and the modal content can be
      // re-rendered late, so re-assert the inline reveal styles idempotently while the modal is open.
      var native = modal.querySelector('.dj-vp-native');
      if (native) {
        native.style.setProperty('display', 'block', 'important');
        native.style.setProperty('position', 'static', 'important');
        native.style.setProperty('width', 'auto', 'important');
        native.style.setProperty('height', 'auto', 'important');
        native.style.setProperty('overflow', 'visible', 'important');
        native.style.setProperty('clip', 'auto', 'important');
        native.style.setProperty('clip-path', 'none', 'important');
        native.style.setProperty('white-space', 'normal', 'important');
        native.style.setProperty('pointer-events', 'auto', 'important');
        native.style.marginTop = '6px';
      }
      // Shorten the add-to-cart label inside the popup: "Lägg till i varukorgen" -> "Lägg i varukorgen".
      var atc = modal.querySelector('button[name="add"]');
      if (atc) shortenLabel(atc);
      // Make the popup thumbnail strip CLICKABLE (theme blocks it with pointer-events:none
      // and a native click doesn't scroll the vertical media column). Re-enable clicks and,
      // on a thumbnail click, scroll the matching image into view in the media scroller.
      var ctrls = modal.querySelector('slideshow-controls');
      if (ctrls) ctrls.style.setProperty('pointer-events', 'auto', 'important');
      if (!modal.__djThumbs) {
        modal.__djThumbs = true;
        modal.addEventListener('click', function (e) {
          var thumb = e.target && e.target.closest ? e.target.closest('.slideshow-controls__thumbnail, slideshow-control') : null;
          if (!thumb || !modal.contains(thumb)) return;
          var thumbs = Array.prototype.slice.call(modal.querySelectorAll('.slideshow-controls__thumbnail, slideshow-control'));
          var idx = thumbs.indexOf(thumb);
          var wrap = modal.querySelector('.product-information__media');
          var slides = modal.querySelectorAll('slideshow-slide');
          if (idx < 0 || !wrap || !slides[idx]) return;
          var target = wrap.scrollTop + (slides[idx].getBoundingClientRect().top - wrap.getBoundingClientRect().top);
          // NOTE: wrap.scrollTo({behavior:'smooth'}) silently does nothing on this element
          // (the media-gallery inside is position:absolute/sticky); direct scrollTop works, so
          // animate scrollTop by hand for a smooth jump to the clicked image.
          var start = wrap.scrollTop, t0 = 0;
          function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 260); wrap.scrollTop = start + (target - start) * (p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2); if (p < 1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
          // If the clicked image is a VIDEO slide, start it playing (the theme's deferred-media
          // only loads/plays on a poster-button click). Enable pointer-events so its controls work.
          var dm = slides[idx].querySelector('deferred-media');
          if (dm) {
            dm.style.setProperty('pointer-events', 'auto', 'important');
            if (!dm.querySelector('video, iframe')) {
              var pb = dm.querySelector('.deferred-media__poster-button');
              if (pb) { try { pb.click(); } catch (er) {} }
            }
          }
        }, true);
      }
    });
  }
  function installQuickAddFix() {
    if (document.__djQaFix) return;
    document.__djQaFix = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t && t.closest && t.closest('.quick-add__button--choose, quick-add-component'))) return;
      var n = 0;
      // Keep re-revealing while a quick-add modal is open (the content can morph in late); stop
      // ~3.6s after it closes, cap ~15s total. Idempotent, so continuous polling is safe.
      var iv = setInterval(function () {
        fixModalVariants();
        n++;
        var open = document.querySelector('dialog.quick-add-modal[open], .quick-add-modal[open]');
        if ((!open && n > 24) || n > 100) clearInterval(iv);
      }, 150);
    }, true);
  }

  /* ---------- 1) Price + shorter label in the MAIN add-to-cart button ---------- */
  var CARD_SEL = 'product-card,.product-card,.card-gallery,quick-add-component,.quick-add,.quick-add-modal,[class*="quick-add"],.product-recommendations,.complementary-products,.resource-list';
  function currentPrice() {
    var pps = qa('product-price');
    for (var i = 0; i < pps.length; i++) {
      if (!pps[i].closest(CARD_SEL)) { var el = pps[i].querySelector('.price'); if (el) return el.textContent.replace(/\s+/g, ' ').trim(); }
    }
    return '';
  }
  // Quantity from the MAIN product form's quantity input (never a card).
  function currentQty() {
    var inputs = qa('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) { if (!inputs[i].closest(CARD_SEL)) { var v = parseInt(inputs[i].value, 10); return (v > 0) ? v : 1; } }
    return 1;
  }
  function priceNum(s) { var n = parseFloat(String(s).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')); return isNaN(n) ? 0 : n; }
  function fmtKr(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'; }
  function mainButtons() {
    // ONLY the product page's main add button. NOT the sticky bar button: the sticky
    // bar already shows the price on the left, and squeezing the price into the narrow
    // sticky button left a stray "middot" (looked like a white dot) on mobile.
    var out = [];
    qa('button[name="add"]').forEach(function (b) { if (!b.closest(CARD_SEL) && !b.closest('.sticky-add-to-cart, sticky-add-to-cart')) out.push(b); });
    return out;
  }
  function shortenLabel(btn) {
    var content = btn.querySelector('.add-to-cart-text__content');
    if (!content) return;
    var deep = content.querySelector('span span') || content.querySelector('span') || content;
    if (deep && deep.textContent.indexOf('Lägg till i varukorgen') > -1) deep.textContent = 'Lägg i varukorgen';
  }
  function injectPrice() {
    var targets = mainButtons();
    qa('.dj-atc-price').forEach(function (s) {
      var btn = s.closest('.sticky-add-to-cart__button, button[name="add"]');
      if (!btn || targets.indexOf(btn) < 0) s.remove();
    });
    if (!targets.length) return;
    var base = currentPrice();
    var qty = currentQty();
    var unit = priceNum(base);
    // Total for the chosen quantity: multiply when qty > 1, else keep the theme's exact string.
    var price = (qty > 1 && unit > 0) ? fmtKr(unit * qty) : base;
    targets.forEach(function (btn) {
      shortenLabel(btn);
      var soldout = btn.disabled || /slutsåld|sold\s*out|ej i lager|utslåld/i.test(btn.textContent);
      var host = btn.querySelector('.add-to-cart-text') || btn;
      var span = btn.querySelector('.dj-atc-price');
      if (soldout || !price) { if (span) span.remove(); return; }
      if (!span) { span = document.createElement('span'); span.className = 'dj-atc-price'; }
      if (span.parentElement !== host) host.appendChild(span);
      var txt = '· ' + price;
      if (span.textContent !== txt) span.textContent = txt;
    });
  }

  /* ---------- 2) Thumbnails follow the main image (smooth, on settle) ---------- */
  function gallery() {
    var mg = q('media-gallery');
    if (!mg) return null;
    var main = mg.querySelector('slideshow-slides');
    var thumbs = qa('.slideshow-controls__thumbnail', mg);
    return (main && thumbs.length) ? { mg: mg, main: main, thumbs: thumbs } : null;
  }
  function hScroller(el) {
    var n = el;
    while (n && n !== document.body) {
      if (n.scrollWidth > n.clientWidth + 2) { var ox = getComputedStyle(n).overflowX; if (ox === 'auto' || ox === 'scroll') return n; }
      n = n.parentElement;
    }
    return null;
  }
  function vScroller(el) {
    var n = el;
    while (n && n !== document.body) {
      if (n.scrollHeight > n.clientHeight + 2) { var oy = getComputedStyle(n).overflowY; if (oy === 'auto' || oy === 'scroll') return n; }
      n = n.parentElement;
    }
    return null;
  }
  function centerNow(thumb) {
    if (!thumb) return;
    var hs = hScroller(thumb);
    if (hs) {
      var tl = thumb.offsetLeft - (hs.clientWidth - thumb.clientWidth) / 2;
      try { hs.scrollTo({ left: Math.max(0, tl), behavior: 'smooth' }); } catch (e) { hs.scrollLeft = Math.max(0, tl); }
    }
    var vs = vScroller(thumb);
    if (vs) {
      var tt = thumb.offsetTop - (vs.clientHeight - thumb.clientHeight) / 2;
      try { vs.scrollTo({ top: Math.max(0, tt), behavior: 'smooth' }); } catch (e) { vs.scrollTop = Math.max(0, tt); }
    }
  }
  var centerT = null;
  function centerSoon(thumb) { if (centerT) clearTimeout(centerT); centerT = setTimeout(function () { centerNow(thumb); }, 90); }
  function bindMain() {
    var g = gallery();
    if (!g || g.main.__djThumbFollow) return;
    g.main.__djThumbFollow = true;
    var scrollT = null;
    g.main.addEventListener('scroll', function () {
      if (scrollT) clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        var w = g.main.clientWidth; if (!w) return;
        var idx = Math.round(g.main.scrollLeft / w);
        if (idx < 0) idx = 0; if (idx > g.thumbs.length - 1) idx = g.thumbs.length - 1;
        centerNow(g.thumbs[idx]);
      }, 140);
    }, { passive: true });
  }
  function bindThumbSelection() {
    var g = gallery();
    if (!g || g.mg.__djThumbSelObs) return;
    g.mg.__djThumbSelObs = true;
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.classList && t.classList.contains('slideshow-controls__thumbnail') && t.getAttribute('aria-selected') === 'true') { centerSoon(t); break; }
      }
    });
    g.thumbs.forEach(function (t) { obs.observe(t, { attributes: true, attributeFilter: ['aria-selected'] }); });
  }

  // Update the ATC-button price live when the main quantity selector changes.
  function bindQty() {
    qa('input[name="quantity"]').forEach(function (inp) {
      if (inp.closest(CARD_SEL) || inp.__djQ) return;
      inp.__djQ = true;
      ['change', 'input'].forEach(function (ev) { inp.addEventListener(ev, function () { injectPrice(); }); });
    });
  }
  var qtyClickBound = false;
  function bindQtyClicks() {
    if (qtyClickBound) return;
    qtyClickBound = true;
    // The +/- buttons update the input value after the click; re-read on a short delay.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t && t.closest)) return;
      if (t.closest('.quantity-selector, quantity-selector, [class*="quantity"]') && !t.closest(CARD_SEL)) {
        setTimeout(injectPrice, 40);
        setTimeout(injectPrice, 180);
      }
    }, true);
  }

  function boot() {
    installCartFeatures();
    installQuickAddFix();
    injectPrice();
    if (!onProductPage()) return;
    bindMain();
    bindThumbSelection();
    bindQty();
    bindQtyClicks();
    var root = document.querySelector('main') || document.body || document.documentElement;
    var mo = new MutationObserver(function () {
      if (mo._busy) return;
      mo._busy = true;
      try { injectPrice(); bindMain(); bindThumbSelection(); bindQty(); } catch (e) {}
      mo._busy = false;
    });
    try { mo.observe(root, { childList: true, subtree: true, characterData: true }); } catch (e) {}
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
